'use strict';

export const nbLikesByAction = (state, getters) => actionID => {
	const request = getters.find({
		query: { action: actionID, $limit: 0 },
		paginate: true,
	});

	return request.total;
};

//=================================================================================================================

export const hasUserLikedAction = (state, getters) => (actionID, userID) => {
	const request = getters.find({
		query: { action: actionID, user: userID, $limit: 0 },
		paginate: true,
	});

	return !!request.total;
};